import { defineRecipe } from "@chakra-ui/react";

/**
 * Chakra v3 Link Recipe
 *
 * Variants: plain (default), underline
 * Supports colorPalette for custom colors
 */
const linkRecipe = defineRecipe({
  className: "link",
  base: {
    display: "inline",
    alignItems: "center",
    cursor: "pointer",
    outline: "none",
    gap: "1.5",
    fontWeight: "medium",
    wordBreak: "break-word",
    colorPalette: "primary",
    color: "colorPalette.fg",
    _focusVisible: {
      outline: "2px solid",
      outlineColor: "colorPalette.focusRing",
      outlineOffset: "2px",
    },
  },
  variants: {
    variant: {
      plain: {
        textDecoration: "none",
        _hover: {
          textDecoration: "underline",
        },
      },
      underline: {
        textDecoration: "underline",
        textUnderlineOffset: "3px",
        textDecorationColor: "currentColor/40",
        _hover: {
          textDecorationColor: "currentColor",
        },
      },
    },
  },
  defaultVariants: {
    variant: "plain",
  },
});

export default linkRecipe;
